






































import { Component, Inject, Vue, Prop } from "vue-property-decorator";
import { mdiChartLineStacked, mdiChartLine, mdiFire, mdiTable } from "@mdi/js";
import { routes } from "../router";
import { HSL } from "../models";

const iconMap = new Map<string, string>();
iconMap.set("popularity", mdiChartLineStacked);
iconMap.set("ranking", mdiChartLine);
iconMap.set("name kindling", mdiFire);

@Component
export default class Navbar extends Vue {
  @Prop({ default: null }) showDrawer!: boolean | null;
  @Prop({ default: 0 }) top!: number;

  @Inject("primaryColour") private primaryColour!: HSL;

  get hoverStyle() {
    const style: { [key: string]: any } = {};
    const { hue } = this.primaryColour;
    let { saturation, light } = this.primaryColour;
    saturation = Math.max(0, saturation - 40);
    light = Math.min(90, light + 50);
    style["--hoverColour"] = `hsl(${hue}, ${saturation}%, ${light}%)`;
    return style;
  }

  toggleOpen() {
    this.$emit("toggle-open");
  }

  iconMap = iconMap;
  streamIcon = mdiChartLineStacked;
  lineIcon = mdiChartLine;
  fireIcon = mdiFire;
  routes = routes;
  mdiTable = mdiTable;
}
